import { useEffect } from 'react';
import Recommended from './recommended';
import FullCatalog from './full-catalog';
import cookies from '../utils/cookies';
import { useSearchParams } from 'react-router';
import { validate as isUUID} from 'uuid';

// the index page is the recommended products or the full catalog...
const CatalogWrapper = () => {
  const [searchParams] = useSearchParams();
  const { prevProductIds, uid, bulk } = Object.fromEntries([...searchParams]);

  useEffect(() => {
    if (prevProductIds) {
      cookies.set('prevProductIds', prevProductIds, 30);
    }
    if (uid && isUUID(uid)) {
      cookies.set('catalogUID', uid, 30);
    }
    if (bulk) {
      cookies.set('bulk', bulk, 30);
    }
  }, [prevProductIds, uid, bulk]);

  const showRecommended = prevProductIds || cookies.get('prevProductIds') ? true : false;

  const showPage = showRecommended ? 'recommended' : null;

  switch (showPage) {
    case 'recommended': {
      return <Recommended />;
    }
    default: {
      return <FullCatalog />;
    }
  }
};

// the index page is the cart...
export default CatalogWrapper;
